import styled from 'styled-components';


export const BoxDate = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 8px;

  h5 {
    font-size: 16px;
    margin: 0px;
    font-weight: 700;
    padding: 0px;
    color: #1A1D28;

    @media (max-width: 500px) {
      font-size: 14px;
    }
  }

  h2 {
    padding: 0px;
    margin: 0;
  }
`;

export const ContainerDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DateText = styled.h5`
  font-size: 16px;
  font-weight: 500;

  span {
    margin-right: 10px;
    padding: 2px 8px;
    border-radius: 4px;
    display: flex;
    gap: 5px;
    color: #828282;
    font-weight: 500;

    @media (max-width: 500px) {
      font-size: 14px;
      margin-right: 0px;
      padding: 2px 0px;
    }
  }
`;

export const LetterThin = styled.div`
    font-weight: 500;
`;

